import React from 'react';
import { Form } from 'react-final-form';

import FormField from 'components/Form/FormField';
import { required, composeValidators, isZip } from 'utils/formValidators';

const LocationForm = ({ onSubmit, onCancel, locationData }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={locationData}
      render={({ handleSubmit, form, submitting }) => (
        <form name="businessLocationForm" onSubmit={handleSubmit}>
          <div className="row p-4">
            <FormField
              label="Address Line 1"
              name="addressLine1"
              containerClassName="col-md-6 mt-2"
              inputClassName="form-control"
              validate={required}
            />
            <FormField
              label="Address Line 2"
              name="addressLine2"
              containerClassName="col-md-6 mt-2"
              inputClassName="form-control"
            />
            <FormField
              label="City"
              name="city"
              containerClassName="col-md-4 mt-2"
              inputClassName="form-control"
              validate={required}
            />
            <FormField
              label="State"
              name="state"
              containerClassName="col-md-4 mt-2"
              inputClassName="form-control"
              validate={required}
            />
            <FormField
              label="Zip"
              name="zip"
              containerClassName="col-md-4 mt-2"
              inputClassName="form-control"
              validate={composeValidators(required, isZip)}
            />
          </div>
          <div className="mt-2 btn-container flex-md-row-reverse flex-column">
            <button
              type="submit"
              disabled={submitting}
              onClick={handleSubmit}
              className="btn btn-warning btn-sm py-3 pl-5 pr-5 text-white text-bold border-0 mb-2"
            >
              Save Changes
            </button>
            <button
              type="button"
              disabled={submitting}
              className="border-0 bg-transparent text-center"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default LocationForm;



// WEBPACK FOOTER //
// ./src/components/businessDetail/businessLocation/locationForm.js